import React from 'react';
import classnames from 'classnames';
import s from './Overlay.scss';
// TODO: refactor and work-into DeviationViews/Thumb/Standard/Overlay
export const Overlay = ({ className , children  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, children);
};
Overlay.displayName = 'Overlay';
export default Overlay;
